import React, { memo } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { BreadcrumbItem } from 'reactstrap';

import cn from 'utils/classnames';

import styles from './Breadcrumb.module.scss';

const AppBreadcrumb = (props) => {
  const {
    className,
    pageTitle,

    breadcrumbList,
  } = props;

  return (
    <div className={styles.Component}>
      <div className={cn('page-title-box', styles.Wrapper, className)}>
        {
          pageTitle && (typeof pageTitle === 'string' ? <h3 className={styles.Title}>{pageTitle}</h3> : pageTitle)
        }
        <div className="page-title-right">
          <ol className="breadcrumb m-0">
            {
              breadcrumbList.map((b) => (
                <BreadcrumbItem key={b.name} active={b.isActive}>
                  {b.link ? (
                    <Link className={b.isActive ? 'Text Text__Link__Active' : 'Text'} to={b.link}>{b.name}</Link>
                  ) : <span className="Text Text__Link__Active">{b.name}</span>}
                </BreadcrumbItem>
              ))
            }
          </ol>
        </div>
      </div>
    </div>
  );
};

AppBreadcrumb.propTypes = {
  className: PropTypes.string,
  pageTitle: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]),

  breadcrumbList: PropTypes.instanceOf(Array),
};

AppBreadcrumb.defaultProps = {
  className: '',
  pageTitle: '',

  breadcrumbList: [{
    name: '',
    link: '#',
  }],
};

export default memo(AppBreadcrumb);
